import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";

const PreSanctionLetter = ({ setNext, setBack, loanApplicationId, classes, isEsign, esingDisable, setEsignDisable, closeModal,initiatorType, featureFlags, loanType, prePledgeLoan, editable }) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [preview, setPreView] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
  setToast(showToast);
  };
  useEffect(() => {
      GetSanctionLetter();
  }, []);
  const handleNext = () => {
    setNext();
  };
  const handleBack = () => {
    setBack();
  };
  const GetSanctionLetter = async () => {
    //SANCTION_LETTER
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.preSanctionLetterLink) {
      setPreView(res?.data?.preSanctionLetterLink);
    }
  };
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "start" }}>
           <SubHeader
            label={headerLabel?.preSanctionLetter}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
            onlyLabel/>
        </GridItem>
      </GridContainer>
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {preview ? <iframe src={preview} width="100%" height="500px" /> : null}
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "end" }}>
          <Button
            size="small"
            className={classes.nextButton1}
            disabled={callInProgress}
            onClick={() => handleBack()}
          >
            Back
          </Button>
          <Button
            size="small"
            className={classes.nextButton}
            disabled={callInProgress || initiatorType === 'CUSTOMER' || !preview}
            onClick={() => handleNext()
            }
          >
            Next
          </Button>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </div>
  );
};

PreSanctionLetter.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
};

export default PreSanctionLetter;